/*
 * @Description: 文件内容描述
 * @Author: 编辑人
 * @Date: 2021-08-10 13:32:23
 */

import request from "@/utils/request";
// 获取省市关系列表
export function qryProAndCityList(data) {
    return request({
        url: "/api/map/provinces",
        method: "post",
        data
    });
}

export function getInfo(data) {
  return request({
      url: "/api/inform/userInfo",
      method: "post",
      data
  })
}

// 获取消息列表
export function qyrInformList(data) {
  return request({
      url: "/api/inform/qyrInformList",
      method: "post",
      data
  });
}
// 新增新消息
export function addNewInform(data) {
  return request({
      url: "/api/inform/addNewInform",
      method: "post",
      data
  });
}
// 修改消息
export function updInform(data) {
  return request({
      url: "/api/inform/updInform",
      method: "post",
      data
  });
}
// 删除消息
export function delInform(data) {
  return request({
      url: "/api/inform/delInform",
      method: "post",
      data
  });
}
// 撤回消息
export function revertInform(data) {
  return request({
      url: "/api/inform/revertInform",
      method: "post",
      data
  });
}
// 发布消息
export function pushInform(data) {
  return request({
      url: "/api/inform/pushInform",
      method: "post",
      data
  });
}

